// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"255":"test","389":"404","962":"home"}[chunkId] || chunkId) + "." + {"255":"11bb507e","389":"c6fa9534","855":"70775900","962":"aabb15b2"}[chunkId] + ".js";
};